import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import AccountsStore from '../../../stores/AccountsStore';
import PreferenceActionCreator from '../../../actions/PreferenceActionCreator';
import PreferencesStore from '../../../stores/PreferencesStore';
import { PaperlessPreferencesSplashModal } from './PaperlessPreferencesSplashModal';
import { ErrorModal } from './ErrorModal';
import { SuccessModal } from './SuccessModal';
import NBAActionCreator from '../../../actions/NBAActionCreator';
import StringConstants from '../../../constants/StringConstants';
import NBAPayload from '../../nba/NBAPayload';
import NBABL from '../../nba/NBABL';
import config from '../../../config/index';
import { AUTO_CHECK } from '../../../constants/PreferencesConstants';

export class PaperlessPreferencesSplash extends Component {
  constructor(props) {
    super(props);
    this.handleAcceptClick = this.handleAcceptClick.bind(this);
    this.handleManageClick = this.handleManageClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);

    const UIState = PreferencesStore.getUIState();

    this.state = {
      apiCallInProgress: UIState.updating,
      updated: UIState.updated,
    };

    PreferencesStore.addChangeListener(this.onStoreChange);
  }

  componentWillUnmount() {
    PreferencesStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    const UIState = PreferencesStore.getUIState();
    this.setState({
      apiCallInProgress: UIState.updating,
      preferenceUpdateFailed: UIState.error,
      updated: UIState.updated,
    });
  }

  handleAcceptClick() {
    const { nbaData } = this.props;
    const splash = NBABL.getSplashData(nbaData);
    const accounts = AccountsStore.getAll();
    const preferences = {
      communication_preferences: [
        {
          accounts: accounts.map(({ id }) => {
            return { id };
          }),
          type: 'Paperless',
          value: 'Y',
        },
      ],
    };
    NBAActionCreator.sendSplashAcknowledgement(
      StringConstants.ACCTSUMM,
      NBAPayload.nbaContainerUserInteraction(
        splash.id,
        splash.offerId,
        config.analytics.analytics_behaviour_positive
      )
    );

    PreferenceActionCreator.updatePreferences(preferences);
  }

  handleManageClick() {
    const { nbaData } = this.props;
    const splash = NBABL.getSplashData(nbaData);
    NBAActionCreator.sendSplashAcknowledgement(
      StringConstants.ACCTSUMM,
      NBAPayload.nbaContainerUserInteraction(
        splash.id,
        splash.offerId,
        config.analytics.analytics_behaviour_more
      )
    );
    PreferenceActionCreator.setMode(AUTO_CHECK);
    InternetBankingActions.navigateToWebTask('WEB-STATEMENTS-PREFERENCES');
  }

  render() {
    const { show, onHide, content } = this.props;

    if (this.state.error) {
      return <ErrorModal show={show} onOkClick={onHide} content={content} />;
    }
    if (this.state.updated) {
      return <SuccessModal show={show} onOkClick={onHide} content={content} />;
    }

    return (
      <PaperlessPreferencesSplashModal
        show={show}
        onHide={onHide}
        content={content}
        onAcceptClick={this.handleAcceptClick}
        onManageClick={this.handleManageClick}
        isLoading={this.state.apiCallInProgress}
      />
    );
  }
}

PaperlessPreferencesSplash.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  nbaData: PropTypes.shape({}),
  content: PropTypes.object,
};
